module.exports = {"body":"<h2>MIT</h2>\n<p>Frauke Wilhelm, Nomena Struß, Ulf Albrecht, Anna Irmgard Jäger, Egon Rammé, Arman Ashkar, Bassam Alatassi, Tatiana, Pitta, Nadia Kavoulakou, Dimitra Gliati, Dimitris Bampilis, Adrian Frieling, Katerina Maoutsou u.a.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./projekte/kanali.sidebar.md
// module id = 1012
// module chunks = 0